import React from 'react';
import LinesEllipsis from 'react-lines-ellipsis';

type ProductButtonProps = {
  title: string;
  textColor: string;
  mediaLink: string;
  background: string;
  buttonStyle?: string;
  hideImage: boolean;
  onClick: () => void;
};

const ProductButton: React.FC<ProductButtonProps> = ({
  title,
  mediaLink,
  background,
  textColor,
  hideImage,
  buttonStyle,
  onClick,
}) => {
  const getCornerRadius = () => {
    if (buttonStyle === 'largeCorner') return 'rounded-[50px]';
    else if (buttonStyle === 'smallCorner') return 'rounded-[10px]';
    else if (buttonStyle === 'noCorner') return 'rounded-none';
    else return 'rounded-[50px]';
  };

  const mediaClass = `relative left-0 w-[54px] h-[54px] self-center justify-self-start object-cover ${getCornerRadius()}`;

  return (
    <button
      type='button'
      onClick={onClick}
      style={{ background: background, color: textColor }}
      className={`
        relative w-full h-productButton flex items-center justify-between flex-shrink-0 px-1.5 shadow-productButton 
        ${buttonStyle ? getCornerRadius() : 'rounded-[50px]'}
      `}
    >
      {!hideImage && (
        <>
          {mediaLink.includes('.mp4') || mediaLink.includes('.webm') ? (
            <video
              loop
              muted
              autoPlay
              width='100%'
              height='100%'
              controls={false}
              playsInline={true}
              className={mediaClass}
            >
              <source
                src={mediaLink}
                type={mediaLink.includes('.mp4') ? 'video/mp4' : 'video/webm'}
              />
            </video>
          ) : (
            <img
              src={mediaLink}
              alt={title.toLowerCase()}
              className={mediaClass}
            />
          )}
        </>
      )}
      <LinesEllipsis
        trimRight
        text={title}
        maxLine={!hideImage ? 3 : 2}
        basedOn='words'
        ellipsis='...'
        className={`
          w-full px-2 font-semibold text-xs sm:text-base !leading-[120%] text-ellipsis overflow-hidden 
          ${
            !hideImage
              ? 'max-w-[calc(100%-108px)] -translate-x-[54px]'
              : 'max-w-full translate-x-0'
          }
        `}
      />
    </button>
  );
};

export default ProductButton;
